/**
 * Nhóm riêng tư hay công khai: máy chủ (group-service) thực thi theo `groupType` (0 công khai, 1 riêng tư),
 * còn `privacySettings` chỉ là chữ tự do nhập lúc tạo nhóm nên không dùng để hiển thị nhãn.
 * Nhận cả bản ghi lồng `{ group: {...} }` mà một số màn đang dùng.
 */
export const isPrivateGroup = (group: any): boolean => {
  const type = group?.groupType ?? group?.group?.groupType;
  if (type === undefined || type === null) return false;
  if (typeof type === 'string') return type === '1' || type.toUpperCase() === 'PRIVATE';
  return Number(type) === 1;
};
